import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AuthoredEvidence, FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  const intl = useIntl();

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__METHOD_OD__DETAIL__PANEL__GENERAL"
            defaultMessage="Všeobecné"
          />
        }
      >
        <FormTextField
          name="code"
          label={
            <FormattedMessage
              id="EAS_EVIDENCE_FIELD_LABEL_CODE"
              defaultMessage="Kód"
            />
          }
          helpLabel={intl.formatMessage({
            id: 'ZSD__METHOD_OD__DETAIL__FIELD_HELP__CODE',
            defaultMessage: 'Je potrebné zadať unikátny identifikátor',
          })}
          required
        />
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="ZSD__METHOD_OD__DETAIL__FIELD_LABEL__NAME"
              defaultMessage="Názov"
            />
          }
          required
        />

        <AuthoredEvidence.AuthoredFields />
      </FormPanel>
    </>
  );
}
